module.exports = __webpack_public_path__ + "static/mural-6-007f1ad1b04c64ec272bac6ee3c1d220.jpg";